import {PAGINATION_DEFAULT_LIMIT, SUPER_ADMIN} from "../../../helpers/constants";
import ReactTable from "react-table";
import {I18n} from "../../../I18n/components/promoter";
import Pagination from "../../Pagination/Pagination";
import React from "react";

const PromoterSalesPointStatsList = props => {
    let firstElementNumber = props.currentPage * PAGINATION_DEFAULT_LIMIT + 1;
    const salesPointStats = props.salesPointStats ? props.salesPointStats : [];
    const tableData = salesPointStats.map((item) => {
        const videoOwnerCompany = props.companies
            ? props.companies.find(company => company.id === item.videoOwnerCompanyId)
            : null;
        const contributorCompany = props.companies
            ? props.companies.find(company => company.id === item.contributorCompanyId)
            : null;
        const salesPoint = props.stores
            ? props.stores.find(store => store.id === item.salesPointId)
            : null;
        // const duration = moment.duration(item.totalDuration);
        // const formattedDuration = util.format(I18n[props.lang].durationFormat,
        //     Math.floor(duration.asHours()),
        //     Math.floor(duration.minutes()),
        //     Math.floor(duration.seconds()));
        return {
            count_id: firstElementNumber++,
            videoOwnerCompanyName: videoOwnerCompany ? videoOwnerCompany.name : '',
            contributorCompanyName: contributorCompany ? contributorCompany.name : '',
            salesPointName: salesPoint? salesPoint.name : '',
            videoName: item.videoName,
            impressionCount: item.impressionCount,
            // totalDuration: formattedDuration,
            deviceCount: item.deviceCount
        };
    });
    return (
        <div className="MyReactTableClass">
            <ReactTable
                getProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            border: "none",
                            padding: "5px 0"
                        }
                    };
                }}
                getTheadProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            boxShadow: "none",
                            padding: "10px 0",
                            fontWeight: "600"
                        }
                    };
                }}
                getTheadThProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            borderRight: "none"
                        }
                    };
                }}
                getTdProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            borderRight: "none",
                        }
                    };
                }}
                getTrProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            alignItems: "center"
                        }
                    };
                }}
                getNoDataProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            top: "100%"
                        }
                    };
                }}
                columns={[
                    {
                        Header: "#",
                        accessor: "count_id",
                        sortable: false,
                        filterable: false,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                            textTransform: "lowercase"
                        },
                        maxWidth: 100
                    },
                    {
                        Header: `${I18n[props.lang].videoOwner}`,
                        accessor: "videoOwnerCompanyName",
                        sortable: false,
                        filterable: false,
                        minWidth: 100,
                        show: props.authority === SUPER_ADMIN,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                        }
                    },
                    {
                        Header: `${I18n[props.lang].company}`,
                        accessor: "contributorCompanyName",
                        sortable: false,
                        filterable: false,
                        minWidth: 100,
                        show: props.authority === SUPER_ADMIN || props.company.types.includes('OPERATOR'),
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                        }
                    },
                    {
                        Header: `${I18n[props.lang].store}`,
                        accessor: "salesPointName",
                        sortable: false,
                        filterable: false,
                        minWidth: 100,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                        }
                    },
                    {
                        Header: `${I18n[props.lang].video}`,
                        accessor: "videoName",
                        sortable: false,
                        filterable: false,
                        minWidth: 100,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                        }
                    },
                    {
                        Header: `${I18n[props.lang].videoImpressions}`,
                        accessor: "impressionCount",
                        sortable: false,
                        filterable: false,
                        minWidth: 100,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                        }
                    },
                    // {
                    //     Header: `${I18n[props.lang].totalDuration}`,
                    //     accessor: "totalDuration",
                    //     sortable: false,
                    //     filterable: false,
                    //     minWidth: 100,
                    //     style: {
                    //         textAlign: "center",
                    //         fontSize: "0.8rem",
                    //     }
                    // },
                    {
                        Header: `${I18n[props.lang].numberOfDevices}`,
                        accessor: "deviceCount",
                        sortable: false,
                        filterable: false,
                        minWidth: 100,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                        }
                    },
                ]}
                PaginationComponent={Pagination}
                nextText={">>"}
                previousText={"<<"}
                defaultPageSize={-1}
                pageSize={tableData.length}
                showPaginationBottom={props.totalPages > 1}
                className="-highlight"
                data={tableData}
                filterable
                manual
                onPageChange={props.setCurrentPage}
                page={props.currentPage}
                pages={props.totalPages}
            />
        </div>
    )
}

export default PromoterSalesPointStatsList;


// WEBPACK FOOTER //
// ./src/components/Promoter/PromoterSalesPointStats/PromoterSalesPointStatsList.js